"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputYoutube = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@unform/core");
var AppContext_1 = __importDefault(require("../AppProvider/AppContext"));
var youtube_service_1 = require("../../services/youtube.service");
var web_1 = require("../Input/web");
var web_2 = require("../LoaderIcon/web");
var InputYoutube_style_1 = __importDefault(require("./InputYoutube.style"));
exports.InputYoutube = function (props) {
    var keyYTB = react_1.useContext(AppContext_1.default).keyYTB;
    var name = props.name, title = props.title, themeInput = props.theme, onInvalidUrl = props.onInvalidUrl, keyYTBComponent = props.keyYTB, rest = __rest(props, ["name", "title", "theme", "onInvalidUrl", "keyYTB"]);
    var _a = react_1.useState(false), error = _a[0], setError = _a[1];
    var _b = react_1.useState(''), invalidVideo = _b[0], setInvalidVideo = _b[1];
    var _c = react_1.useState(false), searching = _c[0], setSearching = _c[1];
    var _d = react_1.useState({}), videoInfo = _d[0], setVideoInfo = _d[1];
    var _e = core_1.useField(name), _f = _e.defaultValue, defaultValue = _f === void 0 ? '' : _f, clearError = _e.clearError;
    var timeOut = react_1.useRef();
    var onChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            e.persist();
            value = e.target.value;
            clearError();
            setInvalidVideo('');
            setSearching(true);
            clearTimeout(timeOut.current);
            timeOut.current = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(value.length > 0)) return [3, 2];
                            return [4, youtube_service_1.YoutubeService(e.target.value, keyYTBComponent !== null && keyYTBComponent !== void 0 ? keyYTBComponent : keyYTB).catch(function (err) {
                                    if (!err.response)
                                        setInvalidVideo('Erro ao verificar id do video, verifique sua internet.');
                                    if (err.response)
                                        setInvalidVideo('Erro ao verificar id do video, estamos verificando.');
                                    return null;
                                })];
                        case 1:
                            data = _a.sent();
                            if (!data) {
                                setError(!data);
                                if (onInvalidUrl) {
                                    onInvalidUrl();
                                }
                            }
                            else {
                                setVideoInfo(data);
                                setError(false);
                            }
                            _a.label = 2;
                        case 2:
                            setSearching(false);
                            return [2];
                    }
                });
            }); }, 300);
            return [2];
        });
    }); };
    react_1.useEffect(function () {
        clearError();
        if (defaultValue.length > 0) {
            youtube_service_1.YoutubeService(defaultValue, keyYTBComponent !== null && keyYTBComponent !== void 0 ? keyYTBComponent : keyYTB)
                .then(function (data) {
                if (!data) {
                    setError(!data);
                    if (onInvalidUrl) {
                        onInvalidUrl();
                    }
                }
                else {
                    setVideoInfo(data);
                    setError(false);
                }
            })
                .catch(function () {
                setError(true);
            });
        }
    }, []);
    return (react_1.default.createElement(InputYoutube_style_1.default, null,
        react_1.default.createElement(web_1.Input, __assign({ name: name, title: title, theme: "gray", "data-cy": name, prefix: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("i", { className: "fab fa-youtube text-danger" })), onInput: function (e) {
                onChange(e);
            } }, rest, { suffix: react_1.default.createElement(react_1.default.Fragment, null, searching && react_1.default.createElement(web_2.LoaderIcon, { size: 24 })) })),
        invalidVideo && (react_1.default.createElement("div", { className: "error-input", "data-testid": "input-error" }, invalidVideo)),
        !error && !!videoInfo.title && (react_1.default.createElement("div", { className: "youtube-container" },
            react_1.default.createElement("div", { className: "img-container" },
                react_1.default.createElement("img", { src: videoInfo.thumbnail, alt: videoInfo.title, "data-cy": "yt-img" })),
            react_1.default.createElement("div", { className: "video-info" },
                react_1.default.createElement("div", { className: "youtube-url" }, "YOUTUBE.COM"),
                react_1.default.createElement("div", { className: "youtube-title", "data-cy": "yt-title" }, videoInfo.title),
                react_1.default.createElement("div", { className: "youtube-description", "data-cy": "yt-description" }, videoInfo.description))))));
};
//# sourceMappingURL=InputYoutube.js.map